
<template>
    
    <div v-if="order.sendOrder !== null">
        <CheckoutPayment :order="order" />
    </div>
    <div v-else>
        <h2>Order Status Page</h2>
        <pre>{{ sessionToken }}</pre>
        <pre>OrderId: {{ orderId }}</pre>
    </div>


</template> 

<script setup>
import CheckoutPayment from '@/components/CheckoutPayment.vue'; 
import { useRoute } from 'vue-router'
import rpAPI from '@shared/service/rpAPI.js';
import { ref } from 'vue';
const route = useRoute()
const sessionToken = route.params.id || null

let orderId = null;
let customerId = null;
const order = ref({
    id: null,
    sendOrder: null
});


if (sessionToken) {
    const parts = sessionToken.split('-');
    const encodedPart = parts[0];
    const decoded = atob(encodedPart);
    orderId = parseInt(decoded);
    customerId = parts.slice(1).join('-');
    // Load Order details using orderId and customerId
    console.log('Decoded Order ID:', orderId);
    console.log('Customer ID:', customerId);
    rpAPI.getOrder(orderId, customerId).then(sendOrder => {
        order.value = {
            id: orderId,
            sendOrder: sendOrder
        }
    }).catch(error => {
        console.error('Error fetching order details:', error);
    });
} else {
    console.log('No session token provided in route params.');
}



</script>